/*jshint esversion: 6 */
var dataToSave = false;
var previousval = "";
var currentval = "";
var adjustment_input_text = "";
var adjustment_note = "";
var eval_order = "";
var adjustment_link = "";
var notes_link = "";
var map_comps_ids = [];
jQuery(window).on("load", function () {
  var segments = location.pathname.split("/");
  let search = location.search.split("/");
  if (
    isInArray("res_evaluations", segments) ||
    isInArray("res_evaluations", search)
  ) {
    var initializeForms = function () {
      if (
        isInArray("overview", segments) &&
        !isInArray("res_comps", segments)
      ) {
        setEvaluationType();
      } else if (isInArray("income", segments)) {
        IncomeApproach.init();
        EvaluationsCommons.init();
        ApproachCalculator.calculateResIncomeApproach();
      } else if (isInArray("sales", segments) || isInArray("sales", search)) {
        EvaluationsCommons.init();
        if (!isInArray("sales", search)) {
          setSalesApproachFields();
        }
      } else if (isInArray("cost", segments) || isInArray("cost", search)) {
        setCostApproachFields();
        EvaluationsCommons.init();
      } else if (isInArray("cost-improvement", segments)) {
        setCostApproachImprovementEvaluationFields();
        EvaluationsCommons.initWeightSetting();
        initType();
      } else if (isInArray("exhibits", segments)) {
        setExhibitFields();
        sortExhibitRows();
        initializeUploadFunctions();
        ApproachCalculator.updateSidebar();
      } else if (isInArray("review", segments)) {
        loadWeightEvents();
        loadlinkMergeEvents();
        showHideFields();
      } else if (
        isInArray("res_evaluations", segments) &&
        segments.length <= 3
      ) {
        loadClientsList();
      }
      setBreadcrumb();
    };

    $("#cost_approach").change(function () {
      if ($(this).prop("checked") == true) {
        $(".select_land_type").addClass("required");
        $(".select_land_type").children("input").prop("required", true);
      } else {
        $(".select_land_type").removeClass("required");
        $(".select_land_type").children("input").prop("required", false);
        $(".select_land_type").children("div.error").remove();
      }
      check_cap_comp_display();
    });

    var showHideFields = function () {
      if ($(".linked_eval_id").length) {
        let flag = 0;
        $(".linked_eval_type").each(function () {
          if ($(this).val() == "commercial") {
            flag = 1;
          }
        });
        if (flag) {
          $(".if-commercial").removeClass("hide");
        } else {
          $(".if-commercial").addClass("hide");
        }
      } else {
        $(".linked_evals_tbl").addClass("hide");
        $(".additional_row_action").addClass("hide");
        $(".get_start_row").removeClass("hide");
      }
    };

    var loadlinkMergeEvents = function () {
      $(document).on("click", ".add_another_eval", function () {
        $("#select-evals").modal("open");
      });
      $(document).on("click", ".get_evals", function () {
        loadEvalsListings();
      });
      $(document).on("click", ".save_linked_evals", function () {
        let form = $("#form_linked_evals");
        let data = new FormData(form[0]);
        saveLinkedEvals(data);
      });
      $(document).on("click", ".get_start", function () {
        $(".get_start_row").addClass("hide");
        $(".linked_evals_tbl").removeClass("hide");
      });
      $(document).on("click", ".adjustedSearch", function () {
        $(".advance_search_btn").addClass("hide");
        $(".advance_filter_form").removeClass("hide");
        $(".get_evals").removeClass("hide");
        $("#eval_tbl_wrap").hide();
      });
      $(document).on("click", ".remove_linked_row", function () {
        $(this).parent().parent().remove();
        if (!$(".additional_row").length) {
          $(".additional_row_action").addClass("hide");
          $(".additional_row").remove();
          $(".linked_evals_tbl").addClass("hide");
          $(".get_start_row").removeClass("hide");
          let form = $("#form_linked_evals");
          let data = new FormData(form[0]);
          saveLinkedEvals(data);
        }
        showHideFields();
      });

      $(document).on("click", ".selectEvalsBtn", function () {
        showAdvanceLoading();
        $(".selectEvalsBtn").attr("disabled", true);
        setTimeout(function () {
          selectEvals();
          $(".selectEvalsBtn").attr("disabled", false);
          hideAdvanceLoading();
        }, 200);
      });
    };

    var saveLinkedEvals = function (data) {
      $.ajax({
        type: "POST",
        url: $("body").data("base-url") + "res_evaluations/saveLinkedEvals",
        data: data,
        async: false,
        cache: false,
        contentType: false,
        processData: false,
        beforeSend: function (xhr) {
          showAdvanceLoading();
        },
        success: function (responseText) {
          let response = JSON.parse(responseText);
          if (response.status.localeCompare("success") === 0) {
            saveToast();
            hideAdvanceLoading();
          }
        },
      });
    };
    var showAdvanceLoading = function () {
      $("body").LoadingOverlay("show", {
        image: $("body").attr("data-base-url") + "assets/img/loading.png",
        imageAnimation: "2500ms rotate_left",
        zIndex: 1005,
        background: "rgba(255, 255, 255, 0.95)",
      });
    };

    var hideAdvanceLoading = function () {
      $("body").LoadingOverlay("hide");
    };

    var selectEvals = function () {
      let ids = [];
      let count = 0;

      $(".select_eval").each(function () {
        if ($(this).is(":checked")) {
          ids.push($(this).val());
          count++;
        }
      });

      if (!count) return Materialize.toast("Please select comps.", 3000, "red");

      $("#select-evals").modal("close");
      loadEvalsEntry(ids);
      clearEvalFilter();
    };

    var loadEvalsEntry = function (id) {
      let eval_search_mode = "commercial";
      let eval_type = "Comm";
      if ($("#eval_search_mode").is(":checked")) {
        eval_search_mode = "residential";
        eval_type = "Res";
      }
      $.ajax({
        type: "GET",
        async: false,
        url: $("body").data("base-url") + "res_evaluations/getEvals",
        data: { id: id, eval_search_mode: eval_search_mode },
        success: function (responseText) {
          const evals = JSON.parse(responseText);
          let row = "";
          $.each(evals, function (i, item) {
            let flag = 1;
            $(".linked_eval_id").each(function () {
              if ($(this).val() == item.id) {
                flag = 0;
              }
            });

            let eval_name = "";
            if ($("#eval_search_mode").is(":checked")) {
              eval_name = item.property_name;
            } else {
              eval_name = item.business_name;
            }
            if (flag) {
              let index = parseInt($("#counter").val()) + 1;
              $("#counter").val(index);
              row +=
                '<tr class="additional_row">' +
                "<td>" +
                '<input type="hidden" class="linked_eval_id" name="evaluation[linked_evals][' +
                index +
                '][id]" value="' +
                item.id +
                '">' +
                '<input type="hidden" class="linked_eval_type" name="evaluation[linked_evals][' +
                index +
                '][eval_type]" value="' +
                eval_search_mode +
                '">' +
                eval_name +
                ", " +
                item.street_address +
                ", " +
                item.city +
                ", " +
                item.state.toUpperCase() +
                ", " +
                item.zipcode +
                "</td>" +
                '<td class="if-commercial hide">' +
                eval_type +
                "</td>" +
                '<td><div class="input-field col">' +
                '<input type="text" name="evaluation[linked_evals][' +
                index +
                '][label]" value="Additional" maxlength="20">' +
                "</div>" +
                "</td>" +
                "<td>" +
                '<input type="checkbox" name="evaluation[linked_evals][' +
                index +
                '][executive]" id="evaluation[linked_evals][' +
                index +
                '][executive]" value="0" onchange="updateValue(this)">' +
                '<label for="evaluation[linked_evals][' +
                index +
                '][executive]"></label>' +
                "</td>" +
                "<td>" +
                '<input type="checkbox" name="evaluation[linked_evals][' +
                index +
                '][overview]" id="evaluation[linked_evals][' +
                index +
                '][overview]" value="0" onchange="updateValue(this)">' +
                '<label for="evaluation[linked_evals][' +
                index +
                '][overview]"></label>' +
                "</td>" +
                "<td>" +
                '<input type="checkbox" name="evaluation[linked_evals][' +
                index +
                '][specs]" id="evaluation[linked_evals][' +
                index +
                '][specs]" value="0" onchange="updateValue(this)">' +
                '<label for="evaluation[linked_evals][' +
                index +
                '][specs]"></label>' +
                "</td>" +
                "<td>" +
                '<input type="checkbox" name="evaluation[linked_evals][' +
                index +
                '][map]" id="evaluation[linked_evals][' +
                index +
                '][map]" value="0" onchange="updateValue(this)">' +
                '<label for="evaluation[linked_evals][' +
                index +
                '][map]"></label>' +
                "</td>" +
                "<td>" +
                '<input type="checkbox" name="evaluation[linked_evals][' +
                index +
                '][boundary]" id="evaluation[linked_evals][' +
                index +
                '][boundary]" value="0" onchange="updateValue(this)">' +
                '<label for="evaluation[linked_evals][' +
                index +
                '][boundary]"></label>' +
                "</td> <td>";
              if (
                item.has_sales_approach !== "0" &&
                item.has_sales_approach != null
              ) {
                row +=
                  '<input type="checkbox" name="evaluation[linked_evals][' +
                  index +
                  '][sca]" id="evaluation[linked_evals][' +
                  index +
                  '][sca]" value="0" onchange="updateValue(this)">' +
                  '<label for="evaluation[linked_evals][' +
                  index +
                  '][sca]"></label>';
              } else {
                row +=
                  "N/A" +
                  '<input type="hidden" name="evaluation[linked_evals][' +
                  index +
                  '][sca]" id="evaluation[linked_evals][' +
                  index +
                  '][sca]" value="N/A">';
              }
              row += "</td> <td>";
              if (
                item.has_income_approach !== "0" &&
                item.has_income_approach != null
              ) {
                row +=
                  '<input type="checkbox" name="evaluation[linked_evals][' +
                  index +
                  '][income]" id="evaluation[linked_evals][' +
                  index +
                  '][income]" value="0" onchange="updateValue(this)">' +
                  '<label for="evaluation[linked_evals][' +
                  index +
                  '][income]"></label>';
              } else {
                row +=
                  "N/A" +
                  '<input type="hidden" name="evaluation[linked_evals][' +
                  index +
                  '][income]" id="evaluation[linked_evals][' +
                  index +
                  '][income]" value="N/A">';
              }
              row += '</td> <td class="if-commercial hide">';
              if (
                item.has_lease_comps !== "0" &&
                item.has_lease_comps != null
              ) {
                row +=
                  '<input type="checkbox" name="evaluation[linked_evals][' +
                  index +
                  '][lease]" id="evaluation[linked_evals][' +
                  index +
                  '][lease]" value="0" onchange="updateValue(this)">' +
                  '<label for="evaluation[linked_evals][' +
                  index +
                  '][lease]"></label>';
              } else {
                row +=
                  "N/A" +
                  '<input type="hidden" name="evaluation[linked_evals][' +
                  index +
                  '][lease]" id="evaluation[linked_evals][' +
                  index +
                  '][lease]" value="N/A">';
              }
              row += '</td> <td class="if-commercial hide">';
              if (item.has_cap_comps !== "0" && item.has_cap_comps != null) {
                row +=
                  '<input type="checkbox" name="evaluation[linked_evals][' +
                  index +
                  '][cap_rate]" id="evaluation[linked_evals][' +
                  index +
                  '][cap_rate]" value="0" onchange="updateValue(this)">' +
                  '<label for="evaluation[linked_evals][' +
                  index +
                  '][cap_rate]"></label>';
              } else {
                row +=
                  "N/A" +
                  '<input type="hidden" name="evaluation[linked_evals][' +
                  index +
                  '][cap_rate]" id="evaluation[linked_evals][' +
                  index +
                  '][cap_rate]" value="N/A">';
              }
              row += '</td> <td class="if-commercial hide">';
              if (
                item.has_multi_family !== "0" &&
                item.has_multi_family != null
              ) {
                row +=
                  '<input type="checkbox" name="evaluation[linked_evals][' +
                  index +
                  '][multi_family]" id="evaluation[linked_evals][' +
                  index +
                  '][multi_family]" value="0" onchange="updateValue(this)">' +
                  '<label for="evaluation[linked_evals][' +
                  index +
                  '][multi_family]"></label>';
              } else {
                row +=
                  "N/A" +
                  '<input type="hidden" name="evaluation[linked_evals][' +
                  index +
                  '][multi_family]" id="evaluation[linked_evals][' +
                  index +
                  '][multi_family]" value="N/A">';
              }
              row += "</td> <td>";
              if (
                item.has_cost_approach !== "0" &&
                item.has_cost_approach != null
              ) {
                row +=
                  '<input type="checkbox" name="evaluation[linked_evals][' +
                  index +
                  '][cost]" id="evaluation[linked_evals][' +
                  index +
                  '][cost]" value="0" onchange="updateValue(this)">' +
                  '<label for="evaluation[linked_evals][' +
                  index +
                  '][cost]"></label>';
              } else {
                row +=
                  "N/A" +
                  '<input type="hidden" name="evaluation[linked_evals][' +
                  index +
                  '][cost]" id="evaluation[linked_evals][' +
                  index +
                  '][cost]" value="N/A">';
              }
              row +=
                "</td>" +
                "<td>" +
                '<i href="#!" class="delete red-text remove_linked_row"><i class="material-icons">remove_circle</i></i>' +
                "</td>" +
                "</tr>";
            } else {
              Materialize.toast(eval_name + " is already linked", 1000);
            }
          });
          $(".additional_row_action").removeClass("hide");
          $("#linked_evals_table tbody").append(row);
          showHideFields();
          clearEvalFilter();
          dataToSave = true;
        },
        failure: function (errMsg) {
          console.error("error:" + errMsg);
          hideAdvanceLoading();
        },
      }).done(function () {
        hideAdvanceLoading();
      });
    };

    var clearEvalFilter = function () {
      $(".advance_search_btn").addClass("hide");
      $(".advance_filter_form").removeClass("hide");
      $(".get_evals").removeClass("hide");
      $("#eval_search_mode").prop("checked", true);
      $("#eval_tbl_wrap").hide();
      $("#eval_data tr").remove();
      $('[name="street_address"]').val("");
      $('[name="street_address"]').parent().find("label").removeClass("active");
      $('[name="start_date"]').val("");
      $('[name="start_date"]').parent().find("label").removeClass("active");
      $('[name="end_date"]').val("");
      $('[name="end_date"]').parent().find("label").removeClass("active");
    };

    var loadEvalsListings = function () {
      $(".advance_search_btn").removeClass("hide");
      $(".advance_filter_form").addClass("hide");
      $(".get_evals").addClass("hide");
      let formValues = $("#form_modal").serialize();
      $.ajax({
        type: "POST",
        url: $("body").data("base-url") + "res_evaluations/get_evals",
        data: formValues,
        beforeSend: function (xhr) {
          showAdvanceLoading();
        },
        success: function (responseText) {
          EvaluationsCommons.resetMarkers();
          let dataTable = $("#evals-modal-table").DataTable();
          dataTable.destroy();
          $("#evals-modal-table").html();
          let eval = JSON.parse(responseText);
          $("#eval_tbl_wrap").show();
          if (eval.response == "") {
            $(".selectCompsBtn").hide();
          } else {
            $(".selectCompsBtn").show();
          }
          if ($("#results_format").is(":checked")) {
            $("#evals-modal-table").addClass("hide");
            if (eval.evals_data == "No record found") {
              $("#response_div").removeClass("hide");
            } else {
              $("#response_div").addClass("hide");
            }
          } else {
            $("#evals-modal-table").removeClass("hide");
            $("#response_div").addClass("hide");
          }
          $("#evals-modal-table").html(eval.response);
          const table = $("#evals-modal-table").DataTable({
            searching: false,
            lengthChange: false,
            pagination: false,
            order: [[2, "desc"]],
            paginate: false,
          });
          // Removing default style as it is causing table not to expand full width
          const headers = table.columns().header();
          headers.each(function (th) {
            $(th).removeAttr("style");
          });
          $("#" + $('[name="evaluation[id]"]').val()).remove();
        },
        error: function (jqXHR, textStatus, errorThrown) {
          if (jqXHR.status == 500) {
            Materialize.toast(errorThrown, 1000);
          } else {
            Materialize.toast("Unexpected error.", 1000);
          }
          hideAdvanceLoading();
        },
      }).done(function () {
        hideAdvanceLoading();
      });
    };

    var loadWeightEvents = function () {
      $('input[name="income_weight"]').on(
        "keyup paste",
        _.debounce(ApproachCalculator.redefineWeight, 500)
      );
      $('input[name="sales_weight"]').on(
        "keyup paste",
        _.debounce(ApproachCalculator.redefineWeight, 500)
      );
      $('input[name="cost_weight"]').on(
        "keyup paste",
        _.debounce(ApproachCalculator.redefineWeight, 500)
      );
    };

    var sortExhibitRows = function () {
      var container = document.getElementById("sort-exhibits");
      var rows = container.children;

      var nodeListForEach = function (array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
          callback.call(scope, i, array[i]);
        }
      };

      var sortableTable = dragula([container], {
        moves: function (el, container, handle) {
          return handle.classList.contains("sort-row");
        },
      });

      sortableTable.on("dragend", function () {
        nodeListForEach(rows, function (index, row) {
          row
            .getElementsByClassName("row-order")[0]
            .setAttribute("data-field-order", index + 1);

          // Iterate through rows, and update orders
          $("#sort-exhibits tr").each(function () {
            var id = $(this).attr("data-id");
            var order = $(this)
              .find("td:last-child span.row-order")
              .attr("data-field-order");

            updateExhibit(id, "order", order);
          });
        });
      });
    };

    var setExhibitFields = function () {
      $(document).on("click", ".remove-exhibit-from-evaluation", function () {
        var $this = $(this);
        deleteConfirm(function () {
          return removeAdditionalExhibit($this);
        }, event);
      });

      $(document).on("click", ".add-new-evaluation-exhibit", function () {
        var template = $("#additional-exhibit-template").html();
        $(".add-new-exhibit-button").first().before(template);
        initializeUploadFunctions();
      });
    };

    var initializeUploadFunctions = function () {
      $("input:file[name='exhibits']").change(function () {
        var file = this.files[0];
        uploadExhibit(
          file,
          $(this).attr("name"),
          $('input[name="evaluation[id]"]').val(),
          $(this)
        );
      });

      $("input[name='title']").change(function () {
        var id = $(this).closest("tr").attr("data-id");
        var field = "filename";
        var value = $(this).val();
        updateExhibit(id, field, value);
      });
    };

    var updateExhibit = function (id, field, value) {
      if (window.FormData === undefined) {
        alert(
          "Please update your browser to a newer version to use this feature."
        );
      } else {
        var formData = new FormData();

        formData.append("id", id);
        formData.append("field", field);
        formData.append("value", value);

        startLoading(".approach-container");
        $.ajax({
          type: "POST",
          url: $("body").attr("data-base-url") + "res_evaluations/put_exhibit",
          data: formData,
          contentType: false,
          processData: false,
          success: function (responseTxt) {
            var response = JSON.parse(responseTxt);
          },
        }).done(function () {
          stopLoading(".approach-container");
        });
      }
    };

    var uploadExhibit = function (file, field, id) {
      if (window.FormData === undefined) {
        alert(
          "Please update your browser to a newer version to use this feature."
        );
      } else {
        var formData = new FormData();

        formData.append("file", file);
        formData.append("id", id);
        formData.append("field", field);
        formData.append("exhibit", true);

        startLoading(".approach-container");
        $.ajax({
          type: "POST",
          url: $("body").attr("data-base-url") + "res_evaluations/post_exhibit", //Server script to process data
          data: formData,
          contentType: false,
          processData: false,
          success: function (responseTxt) {
            var response = JSON.parse(responseTxt);

            if (response.message) {
              Materialize.toast(response.message, 2000);
            }

            location.reload();
          },
        }).done(function () {
          stopLoading(".approach-container");
        });
      }
    };

    var removeAdditionalExhibit = function (obj) {
      if (obj) {
        var compId = $("input[name='evaluation[id]']").val();

        if (typeof compId !== "undefined" && compId !== null) {
          removeExhibit(
            compId,
            obj.attr("data-field-name"),
            obj.attr("data-exhibit-id"),
            function () {
              obj.parent().parent().parent().remove();
            }
          );
        }
      }
    };

    var removeExhibit = function (id, field, file_id, callback) {
      startLoading(".approach-container");
      $.ajax({
        type: "POST",
        url: $("body").data("base-url") + "res_evaluations/remove_exhibit",
        data: {
          id: id,
          field: field,
          file_id: file_id,
        },
        success: function (responseText) {
          var comp = JSON.parse(responseText);

          if (comp.status === "success") {
            if (callback !== undefined) {
              callback();
            }
          }

          if (comp.message) {
            Materialize.toast(comp.message, 2000);
          }
        },
        failure: function (errMsg) {
          console.error("error:" + errMsg);
        },
      }).done(function () {
        stopLoading(".approach-container");
      });
    };

    var setSalesApproachFields = function () {
      setCompHandling();
      loadCompsInSales();
      if ($("#create-new-comp").length) {
        document
          .getElementById("create-new-comp")
          .addEventListener("click", createNewComp);
        loadSideNav();
        ResCompsController.loadSideNav();
      }
    };

    var loadCompsInSales = function () {
      var id = $('input[name="evaluation_sales_approaches[id]"]').val();
      var deferreds = [];
      compsInApproaches = [];

      $.ajax({
        type: "GET",
        url: $("body").data("base-url") + "approaches/get/" + id,
        data: {
          approach: "res_sales",
        },
        success: function (responseText) {
          if (responseText !== "" && responseText !== "null") {
            var response = JSON.parse(responseText);
            if (response != undefined && response.comps) {
              for (var comp in response.comps) {
                if (response.comps.hasOwnProperty(comp)) {
                  deferreds.push(
                    loadExistingComp(response.comps[comp], "sales_approach")
                  );
                }
              }
            } else {
              for (var comp in response) {
                deferreds.push(
                  loadExistingComp(response[comp], "sales_approach")
                );
              }
            }
          }
        },
      }).done(function () {
        $.when.apply($, deferreds).then(function () {
          initComps();
          initializeMasks();
          initOrders();
          ApproachCalculator.calculateResSalesApproach();
        });
      });
    };

    var loadCompsInCost = function () {
      var id = $('input[name="evaluation_cost_approaches[id]"]').val();
      var deferreds = [];
      compsInApproaches = [];

      $.ajax({
        type: "GET",
        url: $("body").data("base-url") + "approaches/get/" + id,
        data: {
          approach: "res_cost",
        },
        success: function (responseText) {
          if (responseText !== "" && responseText !== "null") {
            var response = JSON.parse(responseText);
            if (response != undefined && response.comps) {
              for (var comp in response.comps) {
                if (response.comps.hasOwnProperty(comp)) {
                  deferreds.push(
                    loadExistingComp(response.comps[comp], "cost_approach")
                  );
                }
              }
            } else {
              for (var comp in response) {
                deferreds.push(
                  loadExistingComp(response[comp], "cost_approach")
                );
              }
            }
          }
        },
      }).done(function () {
        $.when.apply($, deferreds).then(function () {
          initComps();
          initializeMasks();
          initOrders();
          ApproachCalculator.calculateResCostApproach();
        });
      });
    };

    var loadExistingComp = function (comp_fields, approach) {
      return $.ajax({
        type: "GET",
        url: $("body").data("base-url") + "res_comps/get",
        data: { id: comp_fields.comp_id, normalize: true },
        success: function (responseText) {
          var comp = JSON.parse(responseText);
          if (comp !== "failure") {
            var comp_entry_template = $(".comp-entry-template")
              .find("div.col.comps")
              .clone();
            comp_entry_template.addClass("comp-entry");
            comp_entry_template.css("display", "none");
            $(comp_entry_template).attr("data-id", comp.id);
            comp_entry_template = setCompFields(comp_entry_template, comp);
            comp_entry_template = setCompInputs(
              comp_entry_template,
              comp_fields,
              approach
            );

            compsInApproaches.push({
              order: parseInt(comp_fields.order),
              template: comp_entry_template[0],
            });
          }
        },
        failure: function (errMsg) {
          console.error("error:" + errMsg);
        },
      });
    };

    var setCompInputs = function (template, comp_fields, approach) {
      for (var key in comp_fields) {
        var field = template.find(
          "[name='evaluation[" + approach + "][comps][index][" + key + "]']"
        );
        var field_custom = template.find(
          "[name='evaluation[" +
            approach +
            "][comps][index][" +
            key +
            "_custom]']"
        );

        if (field) {
          if (comp_fields.hasOwnProperty(key)) {
            if (comp_fields[key]) {
              if (comp_fields[key] == "Type My Own") {
                field_custom
                  .val(comp_fields[key + "_custom"])
                  .trigger("change");
                field_custom.removeClass("hide");
                field_custom.after(
                  "<a class='convert_to_dropdown' style='position: absolute; margin-left:-10px;' onclick = 'convert_to_dropdown(this)'><i class='tiny material-icons'>autorenew</i></a>"
                );
                field.addClass("hide");
                field.val(comp_fields[key]).trigger("change");
              } else {
                field.val(comp_fields[key]).trigger("change");
                if (key == "other_amenities" && comp_fields.other_amenities) {
                  let other_amenities = maskCurrencyLabel(
                    parseFloat(field.val()).toFixed(2)
                  );
                  if (parseFloat(field.val()))
                    template
                      .find(".amenities_adjustment_link")
                      .html(other_amenities);
                  template.find("#amenities_total").html(other_amenities);
                }
              }
              var text = "Click to edit adjustment notes";
              if (key == "adjustment_note" && comp_fields.adjustment_note) {
                template.find(".adjustment_input_text").html(text);
                template.find(".adjustment_link").addClass("hide");
                template.find(".adjustment_input_text").removeClass("hide");
              } else if (
                key == "adjustment_note" &&
                comp_fields.adjustment_note == ""
              ) {
                template.find(".adjustment_link").removeClass("hide");
                template.find(".adjustment_input_text").addClass("hide");
              }
              if (key == "extra_amenity") {
                for (let values in comp_fields[key]) {
                  updateExtraAmenity(template, comp_fields[key][values]);
                }
              }
            }
          }
        }
      }
      return template;
    };

    var updateExtraAmenity = function (template, values) {
      let cloned_row = template.find(".add_another_amenity_row");
      let new_row = cloned_row.after(cloned_row.clone());
      new_row
        .removeClass("hide")
        .removeClass("add_another_amenity_row")
        .addClass("amenity_row");

      let order =
        template
          .find('[name="evaluation[sales_approach][comps][index][order]"]')
          .val() - 1;

      let subject_property_check_id =
        new_row.find(".subject_property_check").attr("id") + order;
      let length = template.find(".subject_property_check").length - 1;
      new_row
        .find(".subject_property_check")
        .attr("id", subject_property_check_id + length);

      new_row
        .find('label[for="subject_property_check"]')
        .attr("for", subject_property_check_id + length);

      let comp_property_check =
        new_row.find(".comp_property_check").attr("id") + order;
      new_row
        .find(".comp_property_check")
        .attr("id", comp_property_check + length);

      new_row
        .find('label[for="comp_property_check"]')
        .attr("for", comp_property_check + length);
      let counter = length - 1;

      let another_amenity_name =
        "evaluation[sales_approach][comps][" +
        order +
        "][extra_amenity][c_index][another_amenity_name]";
      new_row
        .find(".another_amenity_name")
        .attr("name", getTagName(another_amenity_name, counter));
      new_row.find(".another_amenity_name").val(values.another_amenity_name);

      let subject_property_check =
        "evaluation[sales_approach][comps][" +
        order +
        "][extra_amenity][c_index][subject_property_check]";
      let subject_property_checkbox = new_row.find(".subject_property_check");
      subject_property_checkbox.attr(
        "name",
        getTagName(subject_property_check, counter)
      );
      subject_property_checkbox.val(values.subject_property_check);
      if (values.subject_property_check == "1")
        subject_property_checkbox.attr("checked", "checked");

      let comp_property_check_name =
        "evaluation[sales_approach][comps][" +
        order +
        "][extra_amenity][c_index][comp_property_check]";
      let comp_property_checkbox = new_row.find(".comp_property_check");
      comp_property_checkbox.attr(
        "name",
        getTagName(comp_property_check_name, counter)
      );
      comp_property_checkbox.val(values.comp_property_check);
      if (values.comp_property_check == "1")
        comp_property_checkbox.attr("checked", "checked");

      let another_amenity_value =
        "evaluation[sales_approach][comps][" +
        order +
        "][extra_amenity][c_index][another_amenity_value]";
      new_row
        .find(".another_amenity_value")
        .attr("name", getTagName(another_amenity_value, counter));
      return new_row
        .find(".another_amenity_value")
        .val(values.another_amenity_value)
        .keyup();
    };

    var compare = function (a, b) {
      var genreA = a.order;
      var genreB = b.order;

      var comparison = 0;
      if (genreA > genreB) {
        comparison = 1;
      } else if (genreA < genreB) {
        comparison = -1;
      }
      return comparison;
    };

    var initComps = function () {
      compsInApproaches = compsInApproaches.sort(compare);

      for (var comp in compsInApproaches) {
        if (compsInApproaches.hasOwnProperty(comp)) {
          var comps = $(".comp-entry");

          var comp_entry_template = $(compsInApproaches[comp].template);

          if (comps.length !== 0 && comps.length < 3) {
            comps.last().after(comp_entry_template);
          } else if (comps.length === 3) {
            $(".comp-add").addClass("hide");
            comps.last().after(comp_entry_template);
          } else {
            $(".comp-current").after(comp_entry_template);
          }
          comp_entry_template.show("slow");

          if (isInArray("sales", segments)) {
            initializeSpecificDropdowns(
              comp_entry_template.find("select.sales-comps-field"),
              ApproachCalculator.calculateResSalesApproach
            );
            initializeSpecificCustomInput(
              comp_entry_template.find("input.sales-comps-field"),
              ApproachCalculator.calculateResSalesApproach
            );
            initializeSpecificInput(
              comp_entry_template.find("input.select-dollar"),
              ApproachCalculator.calculateResSalesApproach
            );
            initializeSpecificInput(
              comp_entry_template
                .find(".percentage-dropdown-weighting")
                .find("input"),
              ApproachCalculator.calculateResSalesApproach
            );
          } else if (isInArray("cost", segments)) {
            initializeSpecificDropdowns(
              comp_entry_template.find("select.cost-comps-field"),
              ApproachCalculator.calculateResCostApproach
            );
            initializeSpecificCustomInput(
              comp_entry_template.find("input.cost-comps-field"),
              ApproachCalculator.calculateResCostApproach
            );
            initializeSpecificInput(
              comp_entry_template.find("input.select-dollar"),
              ApproachCalculator.calculateResCostApproach
            );
            initializeSpecificInput(
              comp_entry_template
                .find(".percentage-dropdown-weighting")
                .find("input"),
              ApproachCalculator.calculateResCostApproach
            );
          }
          setCompsColors();
        }
      }
    };

    var updateAdjustmentsFactors = function (obj) {
      let value = $(obj)
        .val()
        .replace(/[^\d.-]/g, "");
      let count = $(".comp-entry").length;
      let comp_entry_div = $(".comp-entry");
      for (let i = 0; i < count; i++) {
        let subject_prop_name = $(obj).attr("name").split("[current]")[1];
        let comp_sale_price = $(comp_entry_div[i])
          .find('[name="single_comp[sale_price]"]')
          .val()
          .replace(/[^\d.-]/g, "");
        let comp_element_name =
          '[name="evaluation[sales_approach][comps][index]' +
          subject_prop_name +
          '"]';
        let calculatedVal = 0;
        if ($(obj).hasClass("postmask-percentage-current")) {
          calculatedVal = parseFloat(
            (parseFloat(comp_sale_price) * parseFloat(value)) / 100
          ).toFixed(2);
        } else {
          let diffrence = 0;
          let subject_value = 0;
          let comp_value = 0;
          let span = subject_prop_name.replace("[", "").replace("]", "");

          if (span == "gross_living_area_sf") {
            span = "gross_living_sq_ft";
          }
          if (subject_prop_name != "[basement]") {
            subject_value = $('[name="current' + subject_prop_name + '"')
              .val()
              .replace(/[^\d.-]/g, "");
            comp_value = $(comp_entry_div[i])
              .find("span." + span)
              .html()
              .replace(/[^\d.-]/g, "");
            if (subject_value == "") subject_value = 0;
            if (comp_value == "") comp_value = 0;
            diffrence = parseFloat(subject_value) - parseFloat(comp_value);
            calculatedVal = parseFloat(value * diffrence).toFixed(2);
          } else if (subject_prop_name == "[basement]") {
            subject_value = $(
              '[name="evaluation[sales_approach][current]' +
                subject_prop_name +
                '"'
            )
              .val()
              .replace(/[^\d.-]/g, "");

            let basement_finished = $("#basement_finished")
              .val()
              .replace(/[^\d.-]/g, "");
            let basement_unfinished = $("#basement_unfinished")
              .val()
              .replace(/[^\d.-]/g, "");
            let basement_finished_sq_ft = $(comp_entry_div[i])
              .find("span.basement_finished_sq_ft")
              .html()
              .replace(/[^\d.-]/g, "");
            let basement_unfinished_sq_ft = $(comp_entry_div[i])
              .find("span.basement_unfinished_sq_ft")
              .html()
              .replace(/[^\d.-]/g, "");
            if (subject_value == "") subject_value = 0;
            if (basement_finished == "") basement_finished = 0;
            if (basement_unfinished == "") basement_unfinished = 0;
            if (basement_finished_sq_ft == "") basement_finished_sq_ft = 0;
            if (basement_unfinished_sq_ft == "") basement_unfinished_sq_ft = 0;
            comp_value =
              parseFloat(basement_finished) *
                parseFloat(basement_finished_sq_ft) +
              parseFloat(basement_unfinished) *
                parseFloat(basement_unfinished_sq_ft);
            calculatedVal = parseFloat(
              parseFloat(subject_value) - parseFloat(comp_value)
            ).toFixed(2);
          }
        }
        $(comp_entry_div[i]).find(comp_element_name).val(calculatedVal).keyup();
      }
    };

    $(document).on("click", ".open_add_basement_adjustment_modal", function () {
      $("#add_basement_adjustment_modal").modal("open");
    });

    $(document).on(
      "click",
      ".open_add_amenities_adjustment_modal",
      function () {
        $(".add_amenities_adjustment_modal").modal();
        let template = $(this).parents(".comps");
        template.find("div.add_amenities_adjustment_modal").modal("open");
        let comp_amenities = template.find("span.additional_amenities").html();
        let selected_amenities = [];
        // if (comp_amenities)
        //     selected_amenities = JSON.parse(comp_amenities);
        if (comp_amenities) selected_amenities = comp_amenities.split(", ");

        template.find(".amenity_row").remove();
        template.find(".amenities_td").each(function () {
          let td_data = $(this).attr("data");
          if (selected_amenities.includes(td_data)) {
            $(this).html('<p class="pad-left-40">Yes</p>');
          } else {
            $(this).html('<p class="pad-left-40">No</p>');
          }
        });
        let comp_id = template
          .find('[name="evaluation[sales_approach][comps][index][comp_id]"]')
          .val();
        let id = $('input[name="evaluation_sales_approaches[id]"]').val();
        $.ajax({
          type: "GET",
          async: false,
          url: $("body").data("base-url") + "approaches/get/" + id,
          data: {
            approach: "res_sales",
          },
          success: function (responseText) {
            if (responseText !== "" && responseText !== "null") {
              var response = JSON.parse(responseText);
              if (response != undefined && response.comps) {
                for (var comp in response.comps) {
                  if (response.comps.hasOwnProperty(comp)) {
                    if (comp_id == response.comps[comp].id) {
                      getOrigionalValues(template, response.comps[comp]);
                    }
                  }
                }
              } else {
                for (var comp in response) {
                  if (comp_id == response[comp].comp_id) {
                    getOrigionalValues(template, response[comp]);
                  }
                }
              }
            }
          },
          failure: function (errMsg) {
            console.error("error:" + errMsg);
            stopLoading("body");
          },
        });
      }
    );

    var getOrigionalValues = function (template, comp_fields) {
      for (let key in comp_fields) {
        let field = template.find(
          "[name='evaluation[sales_approach][comps][index][" + key + "]']"
        );

        if (field) {
          if (comp_fields.hasOwnProperty(key)) {
            if (comp_fields[key]) {
              let tempField = template.find(
                '[name="evaluation[sales_approach][comps][index][' + key + ']"]'
              );

              if (tempField.hasClass("another_amenity_value")) {
                const val = parseFloat(comp_fields[key]).toFixed(2);
                tempField.val(val).keyup();
              }
              if (key == "other_amenities" && comp_fields.other_amenities) {
                let other_amenities = maskCurrencyLabel(
                  parseFloat(field.val().replace(/[^\d.-]/g, "")).toFixed(2)
                );
                if (parseFloat(field.val()))
                  template
                    .find(".amenities_adjustment_link")
                    .html(other_amenities);
                template.find("#amenities_total").html(other_amenities);
              }

              if (key == "extra_amenity") {
                for (let values in comp_fields[key]) {
                  updateExtraAmenity(template, comp_fields[key][values]);
                }
              }
            }
          }
        }
      }
    };

    var calculate_basement_adjustment = function (e) {
      let basement_finished = $("#basement_finished")
        .val()
        .replace(/[^\d.-]/g, "");
      let basement_unfinished = $("#basement_unfinished")
        .val()
        .replace(/[^\d.-]/g, "");
      let basement_finished_sq_ft = $(
        '[name="current[basement_finished_sq_ft]"]'
      )
        .val()
        .replace(/[^\d.-]/g, "");
      let basement_unfinished_sq_ft = $(
        '[name="current[basement_unfinished_sq_ft]"]'
      )
        .val()
        .replace(/[^\d.-]/g, "");
      let calculatedVal =
        parseFloat(basement_finished) * parseFloat(basement_finished_sq_ft) +
        parseFloat(basement_unfinished) * parseFloat(basement_unfinished_sq_ft);
      $('[name="evaluation[sales_approach][current][basement_finished]"]').val(
        basement_finished
      );
      $(
        '[name="evaluation[sales_approach][current][basement_unfinished]"]'
      ).val(basement_unfinished);

      if (basement_finished > 0 || basement_unfinished > 0)
        $(".basement_adjustment_link").html(
          $("#basement_finished").val() +
            " / " +
            $("#basement_unfinished").val()
        );
      else $(".basement_adjustment_link").html("Click to add");

      $('[name="evaluation[sales_approach][current][basement]"')
        .val(calculatedVal)
        .change();
      $("#add_basement_adjustment_modal").modal("close");
    };

    var loadSideNav = function () {
      var buttonSettings = {
        menuWidth: "50%",
        edge: "left",
        closeOnClick: false,
      };

      $(".button-evaluation-collapse").sideNav(buttonSettings);

      buttonSettings.onClose = function (el) {
        ResCompsController.resetForm();
      };
      $(".button-comps-collapse").sideNav(buttonSettings);
    };

    var createNewComp = function () {
      $("#select-comp").modal("close");
      clearFilters();
      ResCompsController.openForm(null, true);
      $(".button-comps-collapse").sideNav("show");
    };

    var clearFilters = function () {
      map_comps_ids = [];
      $(".advance_search_btn").addClass("hide");
      $(".advance_filter_form").removeClass("hide");
      $(".get_comps").removeClass("hide");
      var property_type = $('select[name="property_type"]');
      property_type.val("");
      property_type.material_select();
      var property_sub_type = $('select[name="property_sub_type"]');
      property_sub_type.val("");
      property_sub_type.material_select();
      var state = $('select[name="state"]');
      state.val("");
      state.material_select();
      var city = $('select[name="city[]"]');
      city.val("");
      city.material_select();
      $("#results_format").prop("checked", false);
      $("#comp_tbl_wrap").hide();
      $("#comp_data tr").remove();
      $('[name="filter_street_address"]').val("");
      $('[name="filter_street_address"]')
        .parent()
        .find("label")
        .removeClass("active");
      $('[name="start_date"]').val("");
      $('[name="start_date"]').parent().find("label").removeClass("active");
      $('[name="end_date"]').val("");
      $('[name="end_date"]').parent().find("label").removeClass("active");
      $('[name="square_footage_min"]').val("");
      $('[name="square_footage_min"]')
        .parent()
        .find("label")
        .removeClass("active");
      $('[name="square_footage_max"]').val("");
      $('[name="square_footage_max"]')
        .parent()
        .find("label")
        .removeClass("active");
      $('[name="land_sf_min"]').val("");
      $('[name="land_sf_min"]').parent().find("label").removeClass("active");
      $('[name="land_sf_max"]').val("");
      $('[name="land_sf_max"]').parent().find("label").removeClass("active");
    };

    var selectComps = function () {
      var ids = [];
      var count = 0;
      if ($("#results_format").is(":checked")) {
        count = map_comps_ids.length;
        ids = map_comps_ids;
      } else {
        $(".select_comp").each(function () {
          if ($(this).is(":checked")) {
            ids.push($(this).val());
            count++;
          }
        });
      }
      if (!count) return Materialize.toast("Please select comps.", 3000, "red");

      var length = $(".comp-entry").length;
      count = count + length;
      if (count > 4) {
        if (length == 0) {
          Materialize.toast(
            "You can only link a maximum of 4 comps.",
            3000,
            "red"
          );
        } else {
          var max = 4 - length;
          Materialize.toast(
            length +
              " already selected. Now you can only link a maximum of " +
              max +
              " comps.",
            3000,
            "red"
          );
        }
      } else {
        $("#select-comp").modal("close");
        clearFilters();
        loadCompEntry(ids);
      }
    };

    var loadCompEntry = function (id, update = 0) {
      $.ajax({
        type: "GET",
        async: false,
        url: $("body").data("base-url") + "res_comps/get",
        data: { id: id, normalize: true },
        success: function (responseText) {
          var comp = JSON.parse(responseText);
          if (update == 1) {
            $.each(comp, function (i, item) {
              updateExistingComp(item, 1);
            });
          } else {
            $.each(comp, function (i, item) {
              addNewComp(item, 1);
            });
            dataToSave = true;
          }
        },
        failure: function (errMsg) {
          console.error("error:" + errMsg);
          stopLoading("body");
        },
      }).done(function () {
        stopLoading("body");
      });
    };

    $(document).on("click", ".add-label", function () {
      let adjustment_labels = $(".adjustmentlabel");
      let new_label_input = adjustment_labels.last().clone();
      let btn_value = $(this).attr("value");
      let inc_btn_value = parseInt(btn_value) + 1;
      let apprach_name = "";
      if (location.pathname.indexOf("/cost") !== -1) {
        apprach_name = "cost_approach";
      }

      new_label_input
        .find("input")
        .removeClass("counter-label-" + btn_value)
        .addClass("counter-label-" + inc_btn_value);
      new_label_input.find(".delete-label").attr("value", inc_btn_value);
      new_label_input
        .find("input")
        .attr(
          "name",
          "evaluation[" +
            apprach_name +
            "][subject_property_adjustments][" +
            inc_btn_value +
            "]"
        )
        .attr("value", "");
      new_label_input.find(".add-label").attr("value", inc_btn_value);
      new_label_input.find("input").val("");
      new_label_input.find("input").attr("data-name", inc_btn_value);
      adjustment_labels.last().after(new_label_input);
      if ($(".adjustmentlabel").length > 1) {
        $(".delete-label").removeClass("hide");
      }
      let break_row = $(".breakdowns").last().clone().removeClass("break1");
      $(".evaluation-approach-property")
        .find(".breakdowns")
        .last()
        .after(break_row);

      $(".comp-entry").each(function () {
        let drop_row = $(".adj_div")
          .clone()
          .removeClass("adj_div")
          .removeClass("counter-" + btn_value)
          .addClass("counter-" + inc_btn_value);
        $(this).find(".costup").before(drop_row);
        $(this).find(".notes_div").before(drop_row);
        if ($("#comp_adjustment_mode").val() == "Dollar") {
          drop_row
            .find(".dollar-input")
            .closest(".counter-" + inc_btn_value)
            .find("input.select-dollar")
            .attr(
              "name",
              "evaluation[" +
                apprach_name +
                "][comps][index][" +
                inc_btn_value +
                "]"
            );
          drop_row
            .find(".dollar-input")
            .closest(".counter-" + inc_btn_value)
            .find("input.select-dollar")
            .attr(
              "id",
              "evaluation[" +
                apprach_name +
                "][comps][index][" +
                inc_btn_value +
                "]"
            );
        } else {
          drop_row.find("select").material_select();
          drop_row
            .find("select")
            .attr(
              "name",
              "evaluation[" +
                apprach_name +
                "][comps][index][" +
                inc_btn_value +
                "]"
            );
          drop_row.find("select").attr("data", inc_btn_value + "_custom");
          drop_row
            .find("input.custom_field")
            .attr(
              "name",
              "evaluation[" +
                apprach_name +
                "][comps][index][" +
                inc_btn_value +
                "_custom]"
            );
          drop_row
            .find("input.custom_field")
            .addClass(inc_btn_value + "_custom");
        }

        if (location.pathname.indexOf("/cost") !== -1) {
          initializeSpecificDropdowns(
            drop_row.find("select.cost-comps-field"),
            ApproachCalculator.calculateResCostApproach
          );
          initializeSpecificCustomInput(
            drop_row.find("input.cost-comps-field"),
            ApproachCalculator.calculateResCostApproach
          );
          initializeSpecificInput(
            drop_row.find("input.select-dollar"),
            ApproachCalculator.calculateResCostApproach
          );
        }
        drop_row.find("input.select-dollar").on("keyup", function (e) {
          maskCurrency(e, this);
        });
        drop_row.find(".postmask-percentage-field").on("keyup", function (e) {
          maskPercentage(e, this);
        });
      });
      $(this).addClass("hide").attr("disabled", true);
      if ($(".adjustmentlabel").length >= 8) {
        $(".add-label").last().addClass("hide");
        return false;
      }
      $(".add-label").last().removeClass("hide");
    });

    $(document).on("click", ".delete-label", function () {
      let btn_value = $(this).attr("value");
      $(this).closest(".adjustmentlabel").remove();
      $(".counter-" + btn_value).remove();
      if ($(".adjustmentlabel").length == 1) {
        $(".delete-label").addClass("hide");
      }
      $(".add-label").last().removeClass("hide");
      $(".evaluation-approach-property").find(".breakdowns").last().remove();
      $(".adjustmentlabel").first().addClass("break1");
      $(".breakdowns").first().addClass("break1");
      $(".comp-entry").each(function () {
        $(this).find(".selector").first().addClass("break1");
      });
      updateLabelsClass();
      updateCompsInputs();
      if (location.pathname.indexOf("/cost") !== -1) {
        ApproachCalculator.calculateResCostApproach();
      }
    });

    var updateExistingComp = function (comp, isAddDelete = 0) {
      var comp_entry_template;
      $(".comp-entry").each(function () {
        if ($(this).attr("data-id") == comp.id) {
          comp_entry_template = $(this);
        }
      });
      comp_entry_template.addClass("comp-entry");
      comp_entry_template = setCompFields(comp_entry_template, comp);
      $(comp_entry_template).attr("data-id", comp.id);
      comp_entry_template.css("display", "none");
      comp_entry_template.show("slow");
      setCompsColors();
      initializeMasks();
      if (isInArray("sales", segments)) {
        ApproachCalculator.calculateResSalesApproach(isAddDelete);
      } else if (isInArray("cost", segments)) {
        ApproachCalculator.calculateResCostApproach(isAddDelete);
      }
      initOrders();
      ViewManager.save();
    };

    var addNewComp = function (comp, isAddDelete = 0) {
      var comp_entry_template = $(".comp-entry-template")
        .find("div.col.comps")
        .clone();

      var comps = $(".comp-entry");

      if (location.pathname.indexOf("/cost") !== -1) {
        comp_entry_template.find(".dropdown").remove();
        let after_this_adj_div = comp_entry_template.find(
          ".after_this_adj_div"
        );

        $(".label-value").each(function () {
          let adj_div = $(".adj_div").clone();
          after_this_adj_div.after(adj_div.removeClass("adj_div"));
        });

        comp_entry_template.find(".selector").first().addClass("break1");
        let child =
          $("#comp_adjustment_mode").val() == "Dollar"
            ? comp_entry_template.find(".dollar-input")
            : comp_entry_template.find(".percentage-dropdown");
        let apprach_name = "cost_approach";

        let counter = 1;
        $(child).each(function () {
          $(this)
            .closest(".selector")
            .addClass("counter-" + counter);
          const name = $(".counter-label-" + counter).attr("data-name");
          if ($("#comp_adjustment_mode").val() == "Dollar") {
            $(this)
              .closest(".selector")
              .addClass("counter-" + counter);
            $(this)
              .find("input.select-dollar")
              .attr(
                "name",
                "evaluation[" + apprach_name + "][comps][index][" + name + "]"
              )
              .attr(
                "id",
                "evaluation[" + apprach_name + "][comps][index][" + name + "]"
              );
          } else {
            $(this).find("select").material_select();
            $(this)
              .find("select")
              .attr("data", name + "_custom");
            $(this)
              .find("select")
              .attr(
                "name",
                "evaluation[" + apprach_name + "][comps][index][" + name + "]"
              );
            $(this)
              .find("input.custom_field")
              .addClass(name + "_custom");
            $(this)
              .find("input.custom_field")
              .attr(
                "name",
                "evaluation[" +
                  apprach_name +
                  "][comps][index][" +
                  name +
                  "_custom]"
              );
          }
          counter++;
        });
      }

      comp_entry_template.addClass("comp-entry");

      comp_entry_template = setCompFields(comp_entry_template, comp);

      $(comp_entry_template).attr("data-id", comp.id);

      //Set to display none, so later the smooth show transition can be used.
      comp_entry_template.css("display", "none");

      if (comps.length !== 0 && comps.length < 3) {
        comps.last().after(comp_entry_template);
      } else if (comps.length === 3) {
        $(".comp-add").addClass("hide");
        comps.last().after(comp_entry_template);
      } else {
        $(".comp-current").after(comp_entry_template);
      }

      comp_entry_template.show("slow");

      setCompsColors();
      initializeMasks();

      if (isInArray("sales", segments)) {
        ApproachCalculator.calculateResSalesApproach(isAddDelete, 1);
        initializeSpecificInput(
          comp_entry_template.find("input.select-dollar"),
          ApproachCalculator.calculateResSalesApproach
        );
        initializeSpecificInput(
          comp_entry_template
            .find(".percentage-dropdown-weighting")
            .find("input"),
          ApproachCalculator.calculateResSalesApproach
        );
      } else if (isInArray("cost", segments)) {
        ApproachCalculator.calculateResCostApproach(isAddDelete);
        initializeSpecificDropdowns(
          comp_entry_template.find("select.cost-comps-field"),
          ApproachCalculator.calculateCostApproach
        );
        initializeSpecificCustomInput(
          comp_entry_template.find("input.cost-comps-field"),
          ApproachCalculator.calculateCostApproach
        );
        initializeSpecificInput(
          comp_entry_template.find("input.select-dollar"),
          ApproachCalculator.calculateResCostApproach
        );
        initializeSpecificInput(
          comp_entry_template
            .find(".percentage-dropdown-weighting")
            .find("input"),
          ApproachCalculator.calculateResCostApproach
        );
      }
      initOrders();
    };

    var initializeSpecificInput = function (inputs, callback) {
      var count = inputs.length;
      for (var i = 0; i < count; i++) {
        if (inputs[i]) {
          $(inputs[i]).keyup(_.debounce(callback, 500));
        }
      }
      initializeSpecificDollarInput(inputs, callback);
    };

    var initializeSpecificDollarInput = function (selects, callback) {
      var count = selects.length;
      for (var i = 0; i < count; i++) {
        if (selects[i]) {
          $(selects[i]).change(_.debounce(callback, 500));
          $(selects[i]).change(updateSelectLabel);

          var label = $(selects[i])
            .parent()
            .parent()
            .parent()
            .find(".dollar-label")
            .find("label");
          var value = $(selects[i]).val();

          if (parseFloat(value) < 0) {
            label.text("Superior");
            label.css("color", "#49bf6d");
            label.css("font-weight", "bold");
          } else if (parseFloat(value) > 0) {
            label.text("Inferior");
            label.css("color", "#f55454");
            label.css("font-weight", "bold");
          } else {
            label.text("Equal");
            label.css("color", "#9e9e9e");
            label.css("font-weight", "normal");
          }
        }
      }
    };

    var initializeSpecificCustomInput = function (inputs, callback) {
      var count = inputs.length;
      for (var i = 0; i < count; i++) {
        if (inputs[i]) {
          $(inputs[i]).keyup(_.debounce(callback, 500));
          $(inputs[i]).keyup(updateSelectLabel);

          var label = $(inputs[i])
            .parent()
            .parent()
            .parent()
            .find(".percentage-label")
            .find("label");
          var value = $(inputs[i]).val();

          if (
            $(inputs[i]).parent().children().children("select").val() ===
            "Type My Own"
          ) {
            if (parseFloat(value) < 0) {
              label.text("Superior");
              label.css("color", "#49bf6d");
              label.css("font-weight", "bold");
            } else if (parseFloat(value) > 0) {
              label.text("Inferior");
              label.css("color", "#f55454");
              label.css("font-weight", "bold");
            } else {
              label.text("Equal");
              label.css("color", "#9e9e9e");
              label.css("font-weight", "normal");
            }
          }
        }
      }
    };

    var initializeSpecificDropdowns = function (selects, callback) {
      var count = selects.length;
      for (var i = 0; i < count; i++) {
        if (selects[i]) {
          $(selects[i]).material_select();
          $(selects[i]).change(_.debounce(callback, 500));
          $(selects[i]).change(updateSelectLabel);

          var label = $(selects[i])
            .parent()
            .parent()
            .parent()
            .find(".percentage-label")
            .find("label");
          var value = $(selects[i]).val();

          if (parseFloat(value) < 0) {
            label.text("Superior");
            label.css("color", "#49bf6d");
            label.css("font-weight", "bold");
          } else if (parseFloat(value) > 0) {
            label.text("Inferior");
            label.css("color", "#f55454");
            label.css("font-weight", "bold");
          } else {
            label.text("Equal");
            label.css("color", "#9e9e9e");
            label.css("font-weight", "normal");
          }
        }
      }
    };

    var updateSelectLabel = function (e) {
      var label = "";
      label = $(this)
        .parent()
        .parent()
        .parent()
        .find(".dollar-label")
        .find("label");
      if (location.pathname.indexOf("cost") !== -1) {
        if ($("#comp_adjustment_mode").val() == "Dollar") {
          label = $(this)
            .parent()
            .parent()
            .parent()
            .find(".dollar-label")
            .find("label");
        } else {
          label = $(this)
            .parent()
            .parent()
            .parent()
            .find(".percentage-label")
            .find("label");
        }
      }

      var value = $(this).val();
      if ($(this).hasClass("custom_field")) {
        if (e.keyCode == 8 || parseFloat(nStr) > 100) {
          value = value.slice(0, -1);
        }
      }
      if (value == "Type My Own") {
        value = $(this)
          .parent()
          .parent()
          .find("." + $(this).attr("data"))
          .attr("value");
        $(this)
          .parent()
          .parent()
          .append(
            "<a class='convert_to_dropdown' style='position: absolute; margin-left:-10px;' onclick = 'convert_to_dropdown(this)'><i class='tiny material-icons'>autorenew</i></a>"
          );
        $(this)
          .parent()
          .parent()
          .find("." + $(this).attr("data"))
          .removeClass("hide");
        $(this).parent().addClass("hide");
      } else {
        var sign = "";
        if ($(this).val().indexOf("-") != -1) {
          sign = "-";
        }
        value = sign + value.replace(/[^\d.]/g, "");
        $(this)
          .parent()
          .parent()
          .find("." + $(this).attr("data"))
          .addClass("hide");
        $(this).parent().removeClass("hide");
      }
      if (
        label !== null &&
        label !== "undefined" &&
        value !== null &&
        value !== "undefined"
      ) {
        if (parseFloat(value) < 0) {
          label.text("Superior");
          label.css("color", "#49bf6d");
          label.css("font-weight", "bold");
        } else if (parseFloat(value) > 0) {
          label.text("Inferior");
          label.css("color", "#f55454" + "");
          label.css("font-weight", "bold");
        } else {
          label.text("Equal");
          label.css("color", "#9e9e9e");
          label.css("font-weight", "normal");
        }
      }
    };

    var setEvaluationType = function () {
      $('select[name="evaluation[type]"]').change(function () {
        if ($(this).val() === "sale") {
          $("[data-eval-type=sale]").removeClass("hide");
          $("[data-eval-type=non-sale]").addClass("hide");
        } else {
          $("[data-eval-type=sale]").addClass("hide");
          $("[data-eval-type=non-sale]").removeClass("hide");
        }
      });

      if ($('select[name="evaluation[type]"]').val() === "sale") {
        $("[data-eval-type=sale]").removeClass("hide");
        $("[data-eval-type=non-sale]").addClass("hide");
      } else {
        $("[data-eval-type=sale]").addClass("hide");
        $("[data-eval-type=non-sale]").removeClass("hide");
      }
    };

    var setCompFields = function (template, comp) {
      for (var key in comp) {
        var field = template.find("span." + key);

        if (field) {
          if (comp[key + "_for_view"]) {
            field.text(comp[key + "_for_view"]);
            if (key === "land_size") {
              let land_size = comp.land_size;
              if (
                $("input[name='evaluation[landDimension]']").val() === "ACRE" &&
                comp.land_dimension === "SF"
              ) {
                let land_size_for_view = (land_size / 43560).toFixed(3);
                field.text(
                  land_size_for_view > 0
                    ? land_size_for_view.replace(
                        /(\d)(?=(\d\d\d)+(?!\d))/g,
                        "$1,"
                      ) + " AC"
                    : "N/A"
                );
              } else if (
                $("input[name='evaluation[landDimension]']").val() === "SF" &&
                comp.land_dimension === "ACRE"
              ) {
                let land_size_for_view = (land_size * 43560).toFixed(2);
                field.text(
                  land_size_for_view > 0
                    ? land_size_for_view.replace(
                        /(\d)(?=(\d\d\d)+(?!\d))/g,
                        "$1,"
                      ) + " SF"
                    : "N/A"
                );
              } else if (comp.land_dimension === "ACRE") {
                land_size_for_view = land_size;
                field.text(
                  land_size_for_view > 0
                    ? land_size_for_view.replace(
                        /(\d)(?=(\d\d\d)+(?!\d))/g,
                        "$1,"
                      ) + " AC"
                    : "N/A"
                );
              }
            }

            // if(key ==='land_size' && comp.land_dimension ==='ACRE'){
            //     let land_size = parseFloat(comp.land_size);
            //     land_size = land_size.toFixed(3);
            //     let land_size_for_view = (comp.land_size * 43560).toFixed(3);
            //     field.text(land_size_for_view.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")+" SF");
            // }
            if (key === "price_square_foot" && isInArray("cost", segments)) {
              // field.text('$' + (comp.sale_price / comp.land_size).toFixed(2));
              let land_size = comp.land_size;
              if (comp.land_dimension === "ACRE") {
                land_size = comp.land_size * 43560;
              }
              field.text(
                land_size > 0
                  ? "$" +
                      (comp.sale_price / land_size)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                  : "N/A"
              );

              if (
                $("input[name='evaluation[landDimension]']").val() === "ACRE"
              ) {
                let land_size = comp.land_size;
                if (comp.land_dimension !== "ACRE") {
                  land_size = (comp.land_size / 43560).toFixed(3);
                }
                price_square_foot =
                  land_size > 0
                    ? parseFloat(comp.sale_price / land_size).toFixed(2)
                    : 0;
                comp.price_square_foot = price_square_foot;
                // template.find("input[name='single_comp[price_acre]']").val(price_square_foot);
                field.text(
                  price_square_foot.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                );
              }
            }
          } else {
            // get property type from zoning array.
            if (
              key === "zonings" &&
              Array.isArray(comp[key]) &&
              comp[key].length
            ) {
              let gross_living_sq_ft = 0;
              let basement_sf = 0;
              let basement_finished_sq_ft = 0;
              let basement_unfinished_sq_ft = 0;
              for (var i = 0; i < comp.zonings.length; i++) {
                gross_living_sq_ft += parseInt(
                  comp.zonings[i].gross_living_sq_ft
                );
                basement_sf +=
                  parseInt(comp.zonings[i].basement_finished_sq_ft) +
                  parseInt(comp.zonings[i].basement_unfinished_sq_ft);
                basement_finished_sq_ft += parseInt(
                  comp.zonings[i].basement_finished_sq_ft
                );
                basement_unfinished_sq_ft += parseInt(
                  comp.zonings[i].basement_unfinished_sq_ft
                );
              }
              template
                .find("span.gross_living_sq_ft")
                .text(mask(gross_living_sq_ft) + " SF");
              template
                .find("span.basement_finished_sq_ft")
                .text(basement_finished_sq_ft);
              template
                .find("span.basement_unfinished_sq_ft")
                .text(basement_unfinished_sq_ft);
              template.find("span.basement_sf").text(mask(basement_sf) + " SF");
            } else {
              let amenities = "";
              if (key == "additional_amenities") {
                if (comp[key]) {
                  // amenities = String(JSON.parse(comp[key]));
                  amenities = comp[key]
                    .map(function (obj) {
                      return obj.additional_amenities;
                    })
                    .join(", ");
                }
                if (comp.other_amenities) {
                  if (amenities != "")
                    amenities = amenities + ", " + comp.other_amenities;
                  else amenities = comp.other_amenities;
                }
                template.find("span.view_other_amenities").text(amenities);
                template.find("span.additional_amenities").text(amenities);
              } else if (key == "year_built" || key == "year_remodeled") {
                if (
                  key == "year_built" &&
                  comp[key] === null &&
                  comp.year_remodeled !== null
                ) {
                  field.text("N/A / ");
                } else if (
                  key == "year_built" &&
                  comp.year_built &&
                  comp.year_built !== null &&
                  comp.year_remodeled &&
                  comp.year_remodeled !== null
                ) {
                  field.text(comp[key] + " / ");
                } else if (
                  key == "year_remodeled" &&
                  comp[key] === null &&
                  comp.year_built !== null
                ) {
                  field.text("/ N/A");
                } else {
                  field.text(comp[key]);
                }
              } else if (comp[key]) {
                field.text(comp[key]);
              } else {
                field.text("");
              }
            }
          }
        }
      }

      //Check for image.
      if (template.find(".comps-image-approach")) {
        var image = "";
        if (comp.property_image_url) {
          image = $("body").data("cdn-url") + comp.property_image_url;
          let placeholder =
            $("body").data("base-url") + "assets/img/default-placeholder.png";

          template.find(".comps-image-approach").attr("src", image);

          template.find(".image").css({
            "background-image":
              "url('" + image + "'), url('" + placeholder + "')",
          });
        } else {
          image =
            $("body").data("base-url") + "assets/img/default-placeholder.png";

          template.find(".comps-image-approach").attr("src", image);

          template.find(".image").css({
            "background-image": "url(" + image + ")",
          });
        }
      }

      //Sales approach fields
      if (
        template.find(
          "input[name='evaluation[sales_approach][comps][index][comp_id]']"
        )
      ) {
        template
          .find(
            "input[name='evaluation[sales_approach][comps][index][comp_id]']"
          )
          .val(comp.id);
      }
      // if (template.find("input[name='evaluation[sales_approach][comps][index][id]']")) {
      //     template.find("input[name='evaluation[sales_approach][comps][index][id]']").val(comp.id);
      // }

      //cost approach fields
      // if (template.find("input[name='evaluation[cost_approach][comps][index][id]']")) {
      //     template.find("input[name='evaluation[cost_approach][comps][index][id]']").val(comp.id);
      // }
      if (
        template.find(
          "input[name='evaluation[cost_approach][comps][index][comp_id]']"
        )
      ) {
        template
          .find(
            "input[name='evaluation[cost_approach][comps][index][comp_id]']"
          )
          .val(comp.id);
      }

      //Setting comp id, image and building size
      if (template.find("input[name='single_comp[building_size]']")) {
        template
          .find("input[name='single_comp[building_size]']")
          .val(comp.building_size);
      }

      if (template.find("input[name='single_comp[land_size]']")) {
        template
          .find("input[name='single_comp[land_size]']")
          .val(comp.land_size);
      }
      if (template.find("input[name='single_comp[land_dimension]']")) {
        template
          .find("input[name='single_comp[land_dimension]']")
          .val(comp.land_dimension);
      }

      if (template.find("input[name='single_comp[sale_price]']")) {
        template
          .find("input[name='single_comp[sale_price]']")
          .val(comp.sale_price);
      }
      if (template.find("i.view-comp-from-approach")) {
        template.find("i.view-comp-from-approach").attr("data-id", comp.id);
      }

      if (template.find("a.edit-comp-from-approach")) {
        template
          .find("a.edit-comp-from-approach")
          .attr(
            "href",
            $("body").data("base-url") +
              "res_comps/overview/" +
              comp.id +
              "?redirect=" +
              window.location.pathname +
              "&evalId=" +
              $('[name="evaluation[id]"]').val()
          );
      }
      return template;
    };

    var mask = function (value, removeCent) {
      value = isNaN(value) || value == undefined ? 0 : value;
      var newValue = parseFloat(value)
        .toFixed(2)
        .replace(/./g, function (c, i, a) {
          return i && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
        });

      if (removeCent !== undefined) {
        var n = newValue.indexOf(".");
        newValue = newValue.substring(0, n !== -1 ? n : n.length);
        return newValue;
      }

      return newValue;
    };

    var initOrders = function () {
      $(".comp-entry")
        .find('[name="evaluation[sales_approach][comps][index][order]"]')
        .each(function (i, e) {
          $(e).val(i + 1);
        });
      $(".comp-entry")
        .find('[name="evaluation[cost_approach][comps][index][order]"]')
        .each(function (i, e) {
          $(e).val(i + 1);
        });
    };

    var setCostApproachImprovementEvaluationFields = function () {
      $(".cost-approach-improvement").keyup(
        _.debounce(ApproachCalculator.calculateResCostApproach, 500)
      );
      $(".cost-approach-improvement").on("keyup", function () {
        currentval = $(this).val();
        if (previousval !== currentval) {
          dataToSave = true;
        }
      });
      $(
        "input[name='evaluation[cost_approach_improvement][remodel_effect]']"
      ).keyup(_.debounce(ApproachCalculator.calculateAge, 500));

      //Operating Expense Entry Controller
      $(document).on("click", ".delete-cost-approach-improvement", function () {
        var cost_aproach_improvement_entry = $(
          ".cost-approach-improvement-entry"
        );
        if (cost_aproach_improvement_entry.length !== 1) {
          $(this).closest(".cost-approach-improvement-entry").remove();
        } else {
          $(this)
            .closest(".cost-approach-improvement-entry")
            .find("input")
            .val("");
        }
        ApproachCalculator.calculateResCostApproach();
        dataToSave = true;
      });

      $(document).on(
        "click",
        ".add-new-cost-approach-improvement",
        function () {
          var last_improvement_entry = $(
            ".cost-approach-improvement-entry"
          ).last();
          var income_source_row = last_improvement_entry.clone();

          income_source_row.find("input").val("");

          income_source_row.find("input").each(function (i, el) {
            $(el).removeAttr("readonly");
            $(el).removeAttr("data-id");
            $(el).removeClass("disabled-input");
            if (
              $(el).attr("name") ==
              "evaluation[cost_approach_improvement][improvements][index][adjusted_cost]"
            ) {
              $(el).prop("readonly", true);
              $(el).addClass("disabled-input");
            }

            $(el).removeClass("count-total-sf-area");
          });

          income_source_row
            .find(".delete-cost-approach-improvement")
            .removeClass("hide");

          last_improvement_entry.after(income_source_row);

          $(".cost-approach-improvement").change(
            _.debounce(ApproachCalculator.calculateResCostApproach, 500)
          );

          initializeMasks(true);
        }
      );
    };

    var setCompsColors = function () {
      $(".comp-entry").each(function (index) {
        if (index % 2 === 0) {
          $(this)
            .find(".evaluation-approach-property")
            .addClass("comps-background");
        } else {
          $(this)
            .find(".evaluation-approach-property")
            .removeClass("comps-background");
        }
      });
    };

    var setCompHandling = function () {
      $(document).on("click", ".remove-comp-from-approach", function (event) {
        deleteConfirm(removeCompFromApproach, event);
      });

      $(document).on("click", ".add-new-comp", function () {
        $("#select-comp").modal({ dismissible: false });
        $("#select-comp").modal("open");
      });

      $(document).on("click", "#filterCriteria", function () {
        $("#modal-filter-criteria").modal({ dismissible: false });
        $("#modal-filter-criteria").modal("open");
      });

      $(document).on("click", ".view-comp-from-approach", function () {
        if ($(this).data("entity") === "res_evaluation") {
          openForm($(this).data("id"));
          $(".button-evaluation-collapse").sideNav("show");
        } else {
          ResCompsController.openForm($(this).data("id"));
          $(".button-comps-collapse").sideNav("show");
        }
      });

      $(document).on("click", ".selectCompsBtn", function () {
        startLoading("body");
        $(".selectCompsBtn").attr("disabled", true);
        setTimeout(function () {
          selectComps();
          $(".selectCompsBtn").attr("disabled", false);
          stopLoading("body");
        }, 200);
      });
      $(document).on("click", ".adjustedSearch", function () {
        $(".advance_search_btn").addClass("hide");
        $(".advance_filter_form").removeClass("hide");
        $(".get_comps").removeClass("hide");
        $("#comp_tbl_wrap").hide();
      });
      $(document).on("click", ".get_comps", function () {
        loadListings();
      });
      $("#results_format").on("change", function () {
        if (!$(".advance_search_btn").hasClass("hide")) {
          document.querySelector(".get_comps").click();
        }
      });
    };

    var removeCompFromApproach = function (event) {
      if (event.currentTarget) {
        var step = location.pathname.split("/");

        var $this = $(event.currentTarget);

        $this.closest(".comp-entry").remove();

        var comps = $(".comp-entry");

        if (comps.length < 4) {
          $(".comp-add").removeClass("hide");
        }

        if (isInArray("sales", step)) {
          setCompsColors();
          ApproachCalculator.calculateResSalesApproach(1);
        } else if (isInArray("cost", step)) {
          setCompsColors();
          ApproachCalculator.calculateResCostApproach(1);
        }
        initOrders();
        dataToSave = true;
      }
    };

    var setType = function (type) {
      var simple = $("[data-cost-approach-type=simple]");
      var advanced = $("[data-cost-approach-type=advanced]");

      if (type === "simple") {
        simple.removeClass("hide");
        advanced.addClass("hide");

        $("[data-simple-cost-approach-size]").each(function (i, el) {
          var newSize = $(el).data("simple-cost-approach-size");
          var oldSize = $(el).data("advanced-cost-approach-size");

          $(el).addClass(newSize);
          $(el).removeClass(oldSize);
        });

        $(
          "[name='evaluation[cost_approach_improvement][improvements][index][adjusted_psf]']"
        ).removeAttr("readonly");
        $(
          "[name='evaluation[cost_approach_improvement][improvements][index][adjusted_psf]']"
        ).removeClass("disabled-input");
      } else if (type === "advanced") {
        simple.addClass("hide");
        advanced.removeClass("hide");

        $("[data-advanced-cost-approach-size]").each(function (i, el) {
          var newSize = $(el).data("advanced-cost-approach-size");
          var oldSize = $(el).data("simple-cost-approach-size");

          $(el).addClass(newSize);
          $(el).removeClass(oldSize);
        });

        $(
          "[name='evaluation[cost_approach_improvement][improvements][index][adjusted_psf]']"
        ).attr("readonly", "readonly");
        $(
          "[name='evaluation[cost_approach_improvement][improvements][index][adjusted_psf]']"
        ).addClass("disabled-input");
      }

      ApproachCalculator.calculateResCostApproach();
    };

    var openForm = function (id) {
      fillInputs(id);
    };

    var fillInputs = function (id) {
      $.ajax({
        type: "GET",
        url: $("body").data("base-url") + "res_evaluations/get",
        data: { id: id },
        success: function (responseText) {
          var evaluation = JSON.parse(responseText);
          if (evaluation.id) {
            for (var property in evaluation) {
              if (evaluation.hasOwnProperty(property)) {
                var input = $('[name="evaluation[' + property + ']"]');

                if (input.is("input")) {
                  input.val(evaluation[property]);
                  $("label[for='evaluation[" + property + "]']").addClass(
                    "active"
                  );
                } else if (input.is("select")) {
                  input.val(evaluation[property]).change();
                  input.material_select();
                } else if (input.is("textarea")) {
                  input.val(evaluation[property]).change();
                } else {
                  if (property.indexOf("photo") === 0) {
                    if (evaluation[property]) {
                      setImage(evaluation, property);
                    }
                  }
                }
              }
            }
          }
        },
      }).done(function () {
        setEvaluationType();
      });
    };

    var setImage = function (evaluation, property) {
      var url = $("body").data("cdn-url") + evaluation[property];
      var preloaderImg = document.createElement("img");
      preloaderImg.src = url;

      preloaderImg.addEventListener("load", function (event) {
        var output = $(".comps-image-container");

        output.css("background-image", "url('" + url + "')");
        output.css("background-size", "auto 100%");
        output.css("background-position", "center");
        output.css("background-color", "#f9f9f9");
        output.css("background-repeat", "no-repeat");

        $(".comps-image").fadeTo("fast", 0);
      });

      preloaderImg.addEventListener("error", function () {
        $(".comps-image-container").children().first().css("opacity", 1);
      });
    };

    var loadListings = function () {
      map_comps_ids = [];
      EvaluationsCommons.clean();
      $(".advance_search_btn").removeClass("hide");
      $(".advance_filter_form").addClass("hide");
      $(".get_comps").addClass("hide");
      var formValues = $("#form_modal").serialize();
      $.ajax({
        type: "POST",
        url: $("body").data("base-url") + "res_evaluations/get_comps",
        data: formValues,
        beforeSend: function (xhr) {
          startLoading("body");
        },
        success: function (responseText) {
          EvaluationsCommons.resetMarkers();
          var dataTable = $("#comps-modal-table").DataTable();
          dataTable.destroy();
          $("#comps-modal-table").html();
          var comp = JSON.parse(responseText);
          $("#comp_tbl_wrap").show();
          if (comp.response == "") {
            $(".selectCompsBtn").hide();
          } else {
            $(".selectCompsBtn").show();
          }
          if ($("#results_format").is(":checked")) {
            $("#comps-modal-table").addClass("hide");
            if (comp.comps_data == "No record found") {
              $("#listings-map").addClass("hide");
              $("#response_div").removeClass("hide");
            } else {
              $("#response_div").addClass("hide");
              $("#listings-map").removeClass("hide");
            }
          } else {
            $("#comps-modal-table").removeClass("hide");
            $("#listings-map").addClass("hide");
            $("#response_div").addClass("hide");
          }
          $("#comps-modal-table").html(comp.response);
          const table = $("#comps-modal-table").DataTable({
            searching: false,
            lengthChange: false,
            pagination: false,
            order: [[8, "desc"]],
            paginate: false,
          });
          // Removing default style as it is causing table not to expand full width
          const headers = table.columns().header();
          headers.each(function (th) {
            $(th).removeAttr("style");
          });

          $(comp.comps_data).each(function (index, instance) {
            EvaluationsCommons.buildListing(instance);
          });
          EvaluationsCommons.fitBounds();
          EvaluationsCommons.checkMap();
        },
        error: function (jqXHR, textStatus, errorThrown) {
          if (jqXHR.status == 500) {
            Materialize.toast(errorThrown, 1000);
          } else {
            Materialize.toast("Unexpected error.", 1000);
          }
          stopLoading("body");
        },
      }).done(function () {
        stopLoading("body");
      });
    };

    $(".modal-close").click(function () {
      if (location.pathname.indexOf("/review") != -1) {
        clearEvalFilter();
      } else {
        clearFilters();
        $("#flag").val("0");
      }
    });

    $(document).on("click", ".open_add_adjustment_modal", function () {
      if ($(this).attr("data")) {
        $(".notes_title").text($(this).attr("data"));
      }
      $("#add_adjustment_modal").modal("open");
      $("#adjustment_note").parent().find("label").removeClass("active");
      var comp_id = $(this)
        .parents(".comps")
        .find('[name="evaluation[sales_approach][comps][index][id]"]')
        .val();
      var eval_order = $(this)
        .parents(".comps")
        .find('[name="evaluation[sales_approach][comps][index][order]"]')
        .val();
      $("#add_adjustment_modal").find("#eval_screen_type").val("sale");

      $("#add_adjustment_modal").find("#adjustment_comp_id").val(comp_id);
      $("#add_adjustment_modal").find("#eval_order").val(eval_order);
      var eval_id = $('[name="evaluation[id]"]').val();
      var note = "";
      notes_link = "adjustment";
      if (comp_id !== undefined) {
        note = $(this).parents(".comps").find(".adjustment_note").val();
        adjustment_input_text = $(this)
          .parents(".comps")
          .find(".adjustment_input_text");
        adjustment_note = $(this).parents(".comps").find(".adjustment_note");
        adjustment_link = $(this).parents(".comps").find(".adjustment_link");
      } else {
        note = $(this).parents(".comp-current").find(".adjustment_note").val();
        adjustment_input_text = $(this)
          .parents(".comp-current")
          .find(".adjustment_input_text");
        adjustment_note = $(this)
          .parents(".comp-current")
          .find(".adjustment_note");
        adjustment_link = $(this)
          .parents(".comp-current")
          .find(".adjustment_link");
      }
      $("#adjustment_note").val(note);
      if (note != "")
        $("#adjustment_note").parent().find("label").addClass("active");
      $("#add_adjustment_modal").find("#adjustment_eval_id").val(eval_id);
    });

    var setBreadcrumb = function () {
      $(document).on("click", ".evaluations-next", function () {
        unmaskFields();
        var form = $("#evaluation-form");
        send(form);
      });

      $(document).on("click", ".evaluations-previous", function () {
        unmaskFields();
        var form = $("#evaluation-form");
        var url = evaluation_url(form.attr("data-previous"));
        send(form, url);
      });

      $(document).on("click", ".evaluations-previous-skip", function () {
        startLoading("body");
        var form = $("#evaluation-form");
        window.location.href = evaluation_url(form.attr("data-previous"));
      });

      $(document).on("click", ".evaluations-next-skip", function () {
        startLoading("body");
        var form = $("#evaluation-form");
        window.location.href = evaluation_url(form.attr("data-next"));
      });

      $("body.res_evaluations #evaluation-form").on(
        "focus",
        ".select-dropdown",
        function () {
          previousval = $(this).val();
        }
      );

      $("body.res_evaluations #evaluation-form").on(
        "change",
        "select,input[type=checkbox]",
        function () {
          currentval = $(this).val();
          if (previousval !== currentval) {
            dataToSave = true;
          }
        }
      );
      $("body.res_evaluations #evaluation-form").on(
        "change",
        "input[type=checkbox]",
        function () {
          setDefaultWeight();
        }
      );

      $("body.res_evaluations #evaluation-form").on(
        "focus",
        ".wysiwyg .evalsummary,.wysiwyg .evalzoning,.wysiwyg .evalreview",
        function () {
          previousval = $(this).text();
        }
      );

      $("body.res_evaluations #evaluation-form").on(
        "focus",
        ".standalone-datepicker,.evalyear,.evalbaseyear,.ceiling",
        function () {
          previousval = $(this).val();
        }
      );
      $("body.res_evaluations #evaluation-form").on(
        "blur",
        ".wysiwyg .evalsummary,.wysiwyg .evalzoning,.wysiwyg .evalreview",
        function () {
          currentval = $(this).text();
          if (previousval == currentval) {
            return false;
          }
          var form = $("#evaluation-form");
          if (location.pathname.indexOf("/overview") == -1) {
            send(form, false, true);
          } else {
            if (previousval !== currentval) {
              dataToSave = true;
            }
          }
        }
      );

      $("body.res_evaluations #evaluation-form").on(
        "click",
        ".wysiwyg .ql-formats",
        function () {
          currentval = $(this).text();
          if (previousval == currentval) {
            return false;
          }
          var form = $("#evaluation-form");
          send(form, false, true);
        }
      );

      $("body.res_evaluations #evaluation-form").on(
        "blur keyup",
        ".evalyear,.evalbaseyear,.evalceiling",
        function () {
          currentval = $(this).val();
          if (previousval == currentval) {
            return false;
          }
          var form = $("#evaluation-form");
          if (location.pathname.indexOf("/overview") == -1) {
            send(form, false, true);
          } else {
            currentval = $(this).val();
            if (previousval !== currentval) {
              dataToSave = true;
            }
          }
        }
      );
      $("body.res_evaluations #evaluation-form").on(
        "focus",
        "input[type=text]:not(.select-dropdown,#route),input[type=radio]:not(.select-dropdown)",
        function () {
          previousval = $(this).val();
        }
      );

      $(document).on(
        "click",
        ".delete-additional-feature, .delete-additional-traffic-count",
        function () {
          if (location.pathname.indexOf("/overview") !== -1) {
            dataToSave = true;
          }
        }
      );
      $("body.res_evaluations #evaluation-form").on(
        "change",
        ".wysiwyg .textarea,textarea,input[type=text]:not(.select-dropdown,#route),input[type=radio]:not(.select-dropdown)",
        function () {
          var form = $("#evaluation-form");
          currentval = $(this).val();
          if (previousval !== currentval || $(this).is(":radio")) {
            dataToSave = true;
          }
          var data = ViewManager.extractData(form);
          data = checkForUnchecked(data);
        }
      );
    };

    $(document).on("click", ".btn_link", function (e) {
      window.onbeforeunload = null;
      e.stopPropagation();
      if ($(this).attr("id") == "save_changes") {
        var form = $("#evaluation-form");
        send(form, false, true);
      }
      if ($(this).attr("data-object") === undefined) {
        window.location.href = document.referrer;
        window.history.back();
      }
      window.location.href = $(this).attr("data-object");
    });

    var loadClientsList = function () {
      hideShowNextBtn();

      $("select[name=clients]").change(hideShowNextBtn);

      $(".clients-next").click(function () {
        var id = $("select[name=clients]").val();
        onSelectClient(id);
      });
    };

    var checkForUnchecked = function (data) {
      var incomeApproachCheckBox = $(
        "input[name='evaluation[has_income_approach]']"
      );
      if (
        incomeApproachCheckBox.length &&
        !incomeApproachCheckBox.prop("checked")
      ) {
        data["evaluation[has_income_approach]"] = false;
      }
      var salesApproachCheckBox = $(
        "input[name='evaluation[has_sales_approach]']"
      );
      if (
        salesApproachCheckBox.length &&
        !salesApproachCheckBox.prop("checked")
      ) {
        data["evaluation[has_sales_approach]"] = false;
      }
      var costApproachCheckBox = $(
        "input[name='evaluation[has_cost_approach]']"
      );
      if (
        costApproachCheckBox.length &&
        !costApproachCheckBox.prop("checked")
      ) {
        data["evaluation[has_cost_approach]"] = false;
      }
      var lastTransferDateKnown = $(
        "input[name='evaluation[last_transfer_date_known]']"
      );
      if (lastTransferDateKnown.length) {
        if (!lastTransferDateKnown.prop("checked")) {
          data["evaluation[last_transfer_date_known]"] = "no";
          $('input[name ="evaluation[under_contract_price]"]')
            .parent(".input-field")
            .find("label")
            .addClass("active");
          $("#evaluation_last_transferred_date_field").hide();
          $('input[name="evaluation[last_transferred_date]"]').val("");
        } else {
          data["evaluation[last_transfer_date_known]"] = "yes";
          $('input[name ="evaluation[under_contract_price]"]')
            .parent(".input-field")
            .find("label")
            .addClass("active");
          $("#evaluation_last_transferred_date_field").show();
        }
      }
      return data;
    };

    var send = function (form, url, donotreload = false) {
      var valid = false;
      if (isInArray("sales", segments)) {
        removeElements("c_index");
      }
      if (isInArray("cost", segments)) {
        removeElements("c_index");
      }
      if (isInArray("overview", segments)) {
        //IF OVERVIEW FORM, VALIDATE IT
        Utils.setIndexes("zonings", 8);
        valid = form.valid();
        Utils.unsetIndexes("zonings", 8);
      } else {
        valid = true;
      }
      if (valid) {
        if (!donotreload) {
          startLoading("body");
        }
        var data = ViewManager.extractData(form);
        data = checkForUnchecked(data);
        $.ajax({
          type: "POST",
          url: form.attr("action"),
          data: data,
          success: function (responseText) {
            stopLoading("body");
            var response = JSON.parse(responseText);

            if (response.status.localeCompare("success") === 0) {
              saveToast();
              if (!donotreload) {
                if (url) {
                  window.location.href = url;
                } else {
                  window.location.href = createURI(
                    form.attr("data-next"),
                    response.id
                  );
                }
              }
            } else {
              Materialize.toast(response.message, 3000);
            }
          },
          error: function (responseText) {
            window.location.href = url;
          },
        }).done(function () {
          focusInPostMasks();
        });
      } else {
        focusInPostMasks();
        Materialize.toast(
          "There are required fields to be filled. Check them before you proceed.",
          2000,
          "red"
        );
        e.preventDefault();
        return false;
      }
    };

    var removeElements = function (element) {};

    var hideShowNextBtn = function () {
      var id = $("select[name=clients]").val();
      if (id !== null && id !== "undefined" && id.length > 0) {
        $(".clients-next").removeClass("hide");
      } else {
        $(".clients-next").addClass("hide");
      }
    };

    var onSelectClient = function (id) {
      if (id !== null && id !== "undefined") {
        window.location.href = createURI("overview", null, { client: id });
      }
    };

    var initialize = function () {
      $("#evals-table").DataTable({
        searching: true,
        lengthChange: false,
        pagination: true,
        order: [[3, "desc"]],
      });
      $("#comps-modal-table").DataTable({
        searching: false,
        lengthChange: false,
        pagination: false,
        paginate: false,
      });
      initializeForms();
      if ($("#add_adjustment").length)
        document
          .getElementById("add_adjustment")
          .addEventListener("click", saveNotes);
      if ($("#calculate_basement_adjustment").length)
        document
          .getElementById("calculate_basement_adjustment")
          .addEventListener("click", calculate_basement_adjustment);
    };

    var saveNotes = function (e) {
      e.preventDefault();
      var form = $("#add_adjustment_form");
      var data = new FormData(form[0]);
      if (form.valid()) {
        $.ajax({
          type: "POST",
          url: $("body").data("base-url") + "res_evaluations/saveNotes",
          data: data,
          cache: false,
          contentType: false,
          processData: false,
          success: function (responseText) {
            $(".add_adjustment_close").click();
            var adjustment_note_text = $("#adjustment_note").val();
            if (adjustment_note_text == "")
              $(adjustment_input_text).html(
                "Click to add " + notes_link + " notes"
              );
            else
              $(adjustment_input_text).html(
                "Click to edit " + notes_link + " notes"
              );
            $(adjustment_note).val(adjustment_note_text);
            if (adjustment_note != "") $(adjustment_link).addClass("hide");
            return false;
          },
          failure: function (errMsg) {
            Materialize.toast(
              "It was not possible to execute that action.",
              2000
            );
          },
        });
      }
    };

    var closeForm = function () {
      $("#evaluation-sidenav").sideNav("hide");
      $("#evaluation-short-form").validate().resetForm();
    };

    var initType = function () {
      var typeEl = $(
        'select[name="evaluation[cost_approach_improvement][type]"]'
      );
      typeEl.change(function () {
        var type = $(this).val();
        setType(type);
      });
      setType(typeEl.val());
    };

    var createURI = function (nextStep, id, params) {
      if (nextStep) {
        var ret = [];
        for (var d in params) {
          if (params.hasOwnProperty(d)) {
            ret.push(
              encodeURIComponent(d) + "=" + encodeURIComponent(params[d])
            );
          }
        }
        if (id && params) {
          return (
            $("body").data("base-url") +
            "res_evaluations/" +
            nextStep +
            "/" +
            id +
            "?" +
            ret.join("&")
          );
        } else if (id && !params) {
          return (
            $("body").data("base-url") +
            "res_evaluations/" +
            nextStep +
            "/" +
            id
          );
        } else {
          return (
            $("body").data("base-url") +
            "res_evaluations/" +
            nextStep +
            "?" +
            ret.join("&")
          );
        }
      } else {
        return $("body").data("base-url") + "res_evaluations/";
      }
    };

    var unsetIndexes = function (className) {
      $("." + className).each(function (i, e) {
        var el = $(e);

        var name = el.attr("name");
        if (name) {
          name = name.replace(/[0-9]+/g, "index");
          el.attr("name", name);
        }
      });
    };

    var evaluation_url = function (step) {
      var id = $('input[name="evaluation[id]"]').val();
      var client = $('input[name="evaluation[client_id]"]').val();

      if (id) {
        return createURI(step, id);
      } else if (client) {
        return createURI(step, null, { id: client });
      } else {
        return createURI(step);
      }
    };

    var setCostApproachFields = function () {
      setCompHandling();
      loadCompsInCost();
      if ($("#create-new-comp").length) {
        document
          .getElementById("create-new-comp")
          .addEventListener("click", createNewComp);
        loadSideNav();
        ResCompsController.loadSideNav();
      }
    };

    var setIndexes = function (key, totalOfInputs) {
      var counter = 0;
      var index = 0;
      var elements = document.getElementsByClassName(key);

      for (var idx = 0; idx < elements.length; idx++) {
        if (elements[idx].nodeName !== "DIV") {
          if (elements[idx].name) {
            elements[idx].name = elements[idx].name.replace("index", counter);
          }
          index++;
          if (index % totalOfInputs === 0) {
            counter++;
          }
        }
      }
      return true;
    };

    $("#rounding").on("change", function () {
      var roundingVal = $(this).val();
      var acc;
      var roundVal;
      $.ajax({
        type: "POST",
        url: $("body").data("base-url") + "res_evaluations/save",
        async: false,
        data: {
          "evaluation[id]": $("[name='evaluation[id]']").val(),
          "evaluation[rounding]": roundingVal,
        },
        success: function (responseText) {
          var evaluation = JSON.parse(responseText);
          var total = $("input[name=total_incremental_value]").data("value");
          var originalVal = $("input[name=total_incremental_value]").val();

          if (roundingVal == 3) {
            acc = 1000;
          } else if (roundingVal == 5000) {
            acc = 5000;
          } else if (roundingVal == 4) {
            acc = 10000;
          } else if (roundingVal == 5) {
            acc = 100000;
          } else if (roundingVal == 6) {
            acc = 1000000;
          }

          if (roundingVal != 0) roundVal = roundNearest(total, acc);
          else roundVal = originalVal;

          $("#total_incremental_value").val(roundVal);

          if (evaluation.id) {
            saveToast();
          }
        },
      });
    });

    var roundNearest = function (num, acc) {
      total = Math.round(num / acc) * acc;
      return total.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: "currency",
        currency: "USD",
      });
    };

    if (window.ResEvaluationController === undefined) {
      window.ResEvaluationController = {};
    }

    ResEvaluationController.closeForm = closeForm;
    ResEvaluationController.createURI = createURI;
    ResEvaluationController.unsetIndexes = unsetIndexes;
    ResEvaluationController.setIndexes = setIndexes;
    ResEvaluationController.loadCompEntry = loadCompEntry;
    ResEvaluationController.updateAdjustmentsFactors = updateAdjustmentsFactors;
    initialize();
  }
});

function convert_to_dropdown(obj) {
  $(obj).parent().children(".custom_field").val("");
  $(obj).parent().children(".custom_field").addClass("hide");
  $(obj).parent().children().children("select").val("0");
  $(obj).parent().children().children("select").material_select();
  $(obj).parent().children(".select-wrapper").removeClass("hide");
  var label = $(obj)
    .parent()
    .parent()
    .children(".percentage-label")
    .find("label");
  label.html("Equal");
  label.css("color", "#9e9e9e");
  label.css("font-weight", "normal");
  if (location.pathname.indexOf("/res_evaluations/cost") !== -1) {
    ApproachCalculator.calculateResCostApproach();
  }
  $(obj).remove();
}
